import { Col, Row, Table } from "antd";
import { ColumnsType } from 'antd/lib/table';
import { CSSProperties, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { chucVu } from "../../constants";
import { formatVNDIn } from "../../helpers/common";
import { NhanVien_MucLuong_PhuCap } from "../../models/luong/Luong";
import { NhanVienResponse } from "../../models/nhanvien/NhanVien";
import { layDanhMucNhanVien } from "../../services/danhmuc";

const PrintPage = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page {
      size:landscape;
      background-color: white;
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 1cm;
      margin-right: 1cm;
    }
    div {
      font-family:'Times New Roman',Times,serif !important;
    }
    label {
      font-family:'Times New Roman',Times,serif !important;
    }
    .ant-table-tbody {
        padding: 0 !important;
    }
    .ant-table-tbody > tr > td {
        padding: 0 !important;
    }
    .atn-table-summary {
        display: table-header-group;
    }

  }
`;

const InChiTietKhenThuongUngHo = ({ duLieu, thang, title, loaiUngHo }: { duLieu: any, thang: Date, title: String, loaiUngHo?: number }) => {   
    const [columns, setColumns] = useState<any>();
    const [dataTable, setDataTable] = useState<any>();
    const [summary, setSummary] = useState<any>();
    const [chanhVP, setChanhVP] = useState<NhanVienResponse>();
    const [giamDoc, setGiamDoc] = useState<NhanVienResponse>();
    const user = useSelector((state: any) => state.auth.currentUser);
    const thangNam = new Date(thang);

    const isAnCotLuong = loaiUngHo === 0;
    const now = new Date();
    const columnsLuong: ColumnsType<NhanVien_MucLuong_PhuCap> = isAnCotLuong ? [
        { title: 'STT', dataIndex: 'thuTuStr', key: 'thuTuStr', align: 'center' },
        { title: 'Họ và tên', dataIndex: 'hoTen', key: 'hoTen', align: 'center' },
        { title: 'Chức vụ', dataIndex: 'chucVu', key: 'chucVu', align: 'center' },
        { title: 'Mức tiền', dataIndex: 'mucTien', key: 'mucTien', align: 'center' },
    ] : [
        { title: 'STT', dataIndex: 'thuTuStr', key: 'thuTuStr', align: 'center' },
        { title: 'Họ và tên', dataIndex: 'hoTen', key: 'hoTen', align: 'center' },
        { title: 'Chức vụ', dataIndex: 'chucVu', key: 'chucVu', align: 'center' },
        { title: 'Mức lương HĐLĐ', dataIndex: 'mucLuongThucNhan', key: 'mucLuongThucNhan', align: 'center' },
        { title: 'Phụ cấp chức vụ', dataIndex: 'phuCapChucVu', key: 'phuCapChucVu', align: 'center' },
        { title: 'Mức tiền', dataIndex: 'mucTien', key: 'mucTien', align: 'center' },
    ];

    type dataType = {
        key: any,
        hoTen?: any,
        chucVu?: any,
        mucLuongThucNhan?: any,
        phuCapChucVu?: any,
        mucTien?: any,
        thuTuStr?: any,
    };
    const dataTongHop: dataType[] = [
        isAnCotLuong ? {
            key: <em>1</em>,
            thuTuStr: <em>A</em>,
            hoTen: <em>B</em>,
            chucVu: <em>C</em>,
            mucTien: <em>D</em>,
        } : {
            key: <em>1</em>,
            thuTuStr: <em>A</em>,
            hoTen: <em>B</em>,
            chucVu: <em>C</em>,
            mucLuongThucNhan: <em>(1)</em>,
            phuCapChucVu: <em>(2)</em>,
            mucTien: <em>(3)</em>,
        }
    ];

    const layChanhVanPhong = async () => {
        let rs = await layDanhMucNhanVien();
        setChanhVP(rs.filter((item: any) => item.idChucVu == chucVu.chanhVanPhong)[0])
        setGiamDoc(rs.filter((item: any) => item.idChucVu == chucVu.giamDoc)[0])
    }
    const cssFormInNoiDungTien: CSSProperties = {
        textAlign: "right",
        paddingRight: "10px",
        fontFamily: 'Times New Roman'
    };
    const cssFormInNoiDungBenTrai: CSSProperties = {
        textAlign: "left",
        paddingRight: "5px",
        fontFamily: 'Times New Roman'
    };
    const cssFormInNoiDungBenTraiInDam: CSSProperties = {
        textAlign: "left",
        paddingRight: "5px",
        fontFamily: 'Times New Roman',
        fontWeight: 700,
    };
    const cssFormInNoiDungTienInDam: CSSProperties = {
        textAlign: "right",
        paddingRight: "10px",
        fontFamily: 'Times New Roman',
        fontWeight: 700,
    };
    const cssFormInNoiDungCanGiuaInDam: CSSProperties = {
        textAlign: "center",
        fontFamily: 'Times New Roman',
        fontWeight: 800,
    };

    const renderPage = () => {
        var totalMucLuongThucNhan = 0;
        var totalPhuCapChucVu = 0;
        var totalMucTien = 0;
        if (duLieu != undefined && duLieu.length > 0) {
            duLieu.map((item: NhanVien_MucLuong_PhuCap, index: any) => {
                dataTongHop.push({
                    key: index + 2,
                    thuTuStr: <div style={item.idNhanVien == 0 ? cssFormInNoiDungCanGiuaInDam : {}}>{item.thuTuStr}</div>,
                    hoTen: <div style={item.idNhanVien == 0 ? cssFormInNoiDungBenTraiInDam : cssFormInNoiDungBenTrai}>{item.hoTen}</div>,
                    chucVu: < div style={item.idNhanVien == 0 ? cssFormInNoiDungBenTraiInDam : cssFormInNoiDungBenTrai}> {item.tenChucVu}</div >,
                    mucLuongThucNhan: < div style={item.idNhanVien == 0 ? cssFormInNoiDungTienInDam : cssFormInNoiDungTien}> {formatVNDIn(item.mucLuongThucNhan) || "-"}</div >,
                    phuCapChucVu: < div style={item.idNhanVien == 0 ? cssFormInNoiDungTienInDam : cssFormInNoiDungTien}> {formatVNDIn(item.phuCapChucVu) || "-"}</div >,
                    mucTien: < div style={item.idNhanVien == 0 ? cssFormInNoiDungTienInDam : cssFormInNoiDungTien}> {formatVNDIn(item.mucTien) || "-"}</div >,                    
                }
                );
                if (item.idNhanVien != 0) {
                    totalMucLuongThucNhan += item.mucLuongThucNhan;
                    totalPhuCapChucVu += item.phuCapChucVu;
                    totalMucTien += item.mucTien;
                }
            });
        }
        setSummary(
            <>
                <Table.Summary.Row>
                    <Table.Summary.Cell index={0} colSpan={3} align="left"> <label style={{ fontFamily: 'Times New Roman' }}>Tổng cộng</label> </Table.Summary.Cell>
                    {!isAnCotLuong && (
                        <>
                            <Table.Summary.Cell index={4} align="right"> <label style={{ fontFamily: 'Times New Roman' }}>{formatVNDIn(totalMucLuongThucNhan) || "-"} </label> </Table.Summary.Cell>
                            <Table.Summary.Cell index={5} align="right"> <label style={{ fontFamily: 'Times New Roman' }}>{formatVNDIn(totalPhuCapChucVu) || "-"} </label> </Table.Summary.Cell>
                        </>
                    )}
                    <Table.Summary.Cell index={6} align="right"> <label style={{ fontFamily: 'Times New Roman' }}>{formatVNDIn(totalMucTien) || "-"} </label> </Table.Summary.Cell>
                </Table.Summary.Row>
            </>
        );
        setColumns(columnsLuong);
        setDataTable(dataTongHop);
    }

    useEffect(() => {
        renderPage();
        layChanhVanPhong();
    }, [])

    return (
        <>
            <section>
                <div style={{ backgroundColor: 'white' }}>
                    <PrintPage >
                        <div className="text-center pt-2">
                            <Row gutter={8}>
                                <Col span={12} >
                                    <div style={{ fontFamily: 'Times New Roman' }}>ỦY BAN NHÂN DÂN THÀNH PHỐ<br /><label><span style={{ fontFamily: 'Times New Roman' }}> QUỸ ĐẦU TƯ PHÁT TRIỂN</span><hr style={{ borderTop: "1px solid", width: "60%", marginLeft: '12mm', marginTop: "1px", marginBottom: "2px" }} /> </label></div>
                                </Col>
                                <Col span={12}  >
                                    <label style={{ fontFamily: 'Times New Roman' }}>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM <br /> <span style={{ fontFamily: 'Times New Roman' }}>Độc lập - Tự do  - Hạnh phúc</span><hr style={{ borderTop: "1px solid", width: "50%", marginLeft: '18mm', marginTop: "1px", marginBottom: "2px" }} /> </label>
                                </Col>
                                <Col span={24}>
                                    <Row justify="center">
                                        <div className="text-center">
                                            <label style={{ fontFamily: 'Times New Roman' }}>{title}</label>
                                        </div>
                                    </Row>
                                    <Row justify="center">
                                        <label style={{ fontFamily: 'Times New Roman' }}>Tháng {thangNam?.getMonth() + 1} năm {thangNam?.getFullYear()}</label>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            <Col span="24">
                                <div className="card-primary">
                                    <Table
                                        dataSource={dataTable}
                                        pagination={false}
                                        size="small"
                                        columns={columns}
                                        locale={{ emptyText: "Không có dữ liệu" }}
                                        summary={() => summary}
                                        className="custom-table-anttd"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <div className="print-footer">
                            <div className="text-center" style={{ marginTop: '25px' }}>
                                <Row gutter={8}>
                                    <Col span={8} >
                                    </Col>
                                    <Col span={8} >
                                    </Col>
                                    <Col span={8}  >
                                        <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>Đà Nẵng, ngày {("0" + now.getDate()).slice(-2)} tháng {("0" + (now.getMonth() + 1)).slice(-2)} năm {now.getFullYear()}</div>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Người lập</label>
                                    </Col><Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Chánh Văn phòng</label>
                                    </Col>
                                    <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Giám đốc</label>
                                    </Col>
                                </Row>
                            </div>
                            <div className="text-center" style={{ paddingTop: "100px" }}>
                                <Row gutter={8}>
                                    <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{user?.hoTen}</label>
                                    </Col>
                                    <Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{chanhVP?.hoTen}</label>
                                    </Col>
                                    <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{giamDoc?.hoTen}</label>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </PrintPage>
                </div>
            </section>

        </>
    )

}
export default InChiTietKhenThuongUngHo;